module.exports = __webpack_public_path__ + "img/service-zhinengfanqizha1.e1cd2dd8.svg";